import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import {
  BrandsEnum,
  IComponentWrapper,
  ISkeeper,
  SdComponentWrapperComponent,
  SizesEnum,
  ThemesEnum,
  ComponentWrapperWidthEnum, MarginEnum
} from '@seb/web-design-system/core';
import { LameConfig } from '@seb/web-common/core/models';
import { BrandCornerMapper } from '@seb/web-common/core/mappers';
import { waitForElm } from '@seb/web-common/core/utils';

@Component({
  selector: 'wc-product-reviews',
  templateUrl: './product-reviews.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdComponentWrapperComponent]
})
export class ProductReviewsComponent implements OnInit {
  wrapperContent: IComponentWrapper;
  lameConfig: LameConfig;
  themesConfig: ThemesEnum = ThemesEnum.default;
  ComponentWrapperWidthEnum = ComponentWrapperWidthEnum;
  MarginEnum = MarginEnum;

  @Input()
  brand = BrandsEnum.default;

  @Input()
  objSkeeper: ISkeeper;

  @Input()
  pageTemplate: '';

  constructor(
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) protected platformId: any,
    private brandCornerMapper: BrandCornerMapper,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.lameConfig = this.brandCornerMapper.toWcConfig(this.brand)?.pdp?.reviews;
      this.wrapperContent = {
        titleLevel: 2,
        links: [],
        footNotes: [],
        heading: {
          titleThemesConfig: this.lameConfig?.titleTheme,
          isUnderlined: this.lameConfig?.titleUnderlined,
          size: SizesEnum.l,
          data: {
            title: this.translateService.instant('ratings.headline')
          },
          titleLevel: 2
        }
      };
      waitForElm('.skeepers_product__reviews').then(() => {
        window['SkeepersProductWidget'].generate();
      });
    }
  }
}
